// non vue related front end scripts

require('./accordions')
require('./iframes')
require('./swiper-sliders')
require('./logo')
